import { createContext, useContext } from 'react';
import { ICoreContext } from '@vivli/core/infrastructure/interface';

export const CoreContext = createContext<ICoreContext>(null);

export const useAppConfigContext = () => useContext(CoreContext).config;
export const useAssignedAppTypeContext = () => useContext(CoreContext).assignedAppType;
export const usePortalConfigContext = () => useContext(CoreContext).portalConfig;
export const useModalApiContext = () => useContext(CoreContext).modalApi;
export const useToastApiContext = () => useContext(CoreContext).toastApi;
